import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { configure } from 'mobx';
import { createRoot } from 'react-dom/client';
import { BugsnagEventLogger, EventLogger } from '../models/Logging';
import { ReactQueryProvider } from '../web/ReactQueryProvider';
import { ApiClientContextProvider } from './contexts/apiClient';
import { EventsRouter } from './EventsRouter';
import './main.less';

const bugsnagEventLogger = new BugsnagEventLogger(import.meta.env.MODE);
const ErrorBoundary = bugsnagEventLogger.getErrorBoundary();
EventLogger.addLogger(bugsnagEventLogger);

document.addEventListener('DOMContentLoaded', async () => {
	configure({ enforceActions: 'never' });

	const container = document.getElementById('react-root');
	if (!container) throw new Error('Root element #react-root not found');
	const root = createRoot(container);
	root.render(
		<ErrorBoundary>
			<ReactQueryProvider>
				<ApiClientContextProvider>
					<EventsRouter />
				</ApiClientContextProvider>
				<ReactQueryDevtools buttonPosition='bottom-left' initialIsOpen={false} />
			</ReactQueryProvider>
		</ErrorBoundary>
	);
});
